// src/utils/sessionStorage.ts

import {
  REFRESH_TOKEN_KEY,
  REGISTRATION_STEP_KEY,
  REGISTRATION_TOKEN_KEY,
  REGISTRATION_USERNAME_KEY,
  SESSION_TOKEN_KEY,
} from '@/constants';
import type { RegistrationStep } from '@/types/AuthState';

export function setRegistrationToken(token:string): void {
  sessionStorage.setItem(REGISTRATION_TOKEN_KEY, token);
}

export function getRegistrationToken(): string | null {
  return sessionStorage.getItem(REGISTRATION_TOKEN_KEY);
}

export function clearRegistrationToken(): void {
  sessionStorage.removeItem(REGISTRATION_TOKEN_KEY);
}

export function setRegistrationUsername(username: string): void {
  sessionStorage.setItem(REGISTRATION_USERNAME_KEY, username);
}

export function getRegistrationUsername(): string | null {
  return sessionStorage.getItem(REGISTRATION_USERNAME_KEY);
}

export function clearRegistrationUsername(): void {
  sessionStorage.removeItem(REGISTRATION_USERNAME_KEY);
}

function isRegistrationStep(value: string | null): value is RegistrationStep {
  return value === 'emailCode' || value === 'phoneCode' || value === 'password' || value === 'complete';
}

export function setRegistrationStep(step: RegistrationStep): void {
  sessionStorage.setItem(REGISTRATION_STEP_KEY, step);
}

export function getRegistrationStep(): RegistrationStep | null {
  const value = sessionStorage.getItem(REGISTRATION_STEP_KEY);
  return isRegistrationStep(value) ? value : null;
}

export function clearRegistrationStep(): void {
  sessionStorage.removeItem(REGISTRATION_STEP_KEY);
}

export function clearRegistrationSession(): void {
  clearRegistrationStep();
  clearRegistrationToken();
  clearRegistrationUsername();
}

export function setSessionToken(token: string): void {
  sessionStorage.setItem(SESSION_TOKEN_KEY, token);
}

export function getSessionToken(): string | null {
  return sessionStorage.getItem(SESSION_TOKEN_KEY);
}

export function clearSessionToken(): void {
  sessionStorage.removeItem(SESSION_TOKEN_KEY);
}

export function setUkekInStorage(userId: string, ukek: string): void {
  sessionStorage.setItem(`${userId}-ukek`, ukek);
}

export function getUkekFromStorage(userId: string): string | null {
  return sessionStorage.getItem(`${userId}-ukek`);
}

export function clearUkekFromStorage(userId: string): void {
  sessionStorage.removeItem(`${userId}-ukek`);
}

export function getRefreshToken(): string | null {
  return sessionStorage.getItem(REFRESH_TOKEN_KEY);
}

export function setRefreshToken(token: string): void {
  sessionStorage.setItem(REFRESH_TOKEN_KEY, token);
}

function clearRefreshToken(): void {
  sessionStorage.removeItem(REFRESH_TOKEN_KEY);
}

export function clearAuthTokens(): void {
  clearSessionToken();
  clearRefreshToken();
}
